import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { Page } from "@/components/ui/layout/page/page";
import {
  HeaderRoot,
  HeaderUpButton,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { SubscribedAssist } from "@/components/assist/subscribed-assist-pro";
import { validatePackageAccess } from "@/lib/assist-package-guard";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { useGraphQL } from "@/hooks/use-graphql";
import { ServicePackageEnum } from "@/lib/enums/service-package-enum";

import type { JSX } from "react";

const SubscribedAssistProQuery = graphql(
  /* GraphQL */ `
  query SubscribedAssistProQuery($codPacoteServicos: Int!) {
    servicePackage: pacotesServicos_by_pk(codPacoteServicos: $codPacoteServicos) {
      pacotesServicosPreco {
        ...SubscribedAssistFragment
      }
    }
  }
  `,
);

const SubscribedAssistPage = (): JSX.Element => {
  const queryResult = useGraphQL(SubscribedAssistProQuery, {
    codPacoteServicos: ServicePackageEnum.Pro.valueOf(),
  });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="Livance Assist Pro" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data?.servicePackage?.pacotesServicosPreco ? (
            <SubscribedAssist data={data.servicePackage.pacotesServicosPreco} />
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/subscribed-assist/")({
  component: SubscribedAssistPage,
  beforeLoad: ({ context }) => {
    const { user } = context;
    validatePackageAccess({ user, packageService: ServicePackageEnum.Pro });
  },
});
